import { render, staticRenderFns } from "./FinanceExpenses.vue?vue&type=template&id=22b4b738&scoped=true&"
import script from "./FinanceExpenses.vue?vue&type=script&lang=js&"
export * from "./FinanceExpenses.vue?vue&type=script&lang=js&"
import style0 from "./FinanceExpenses.vue?vue&type=style&index=0&id=22b4b738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b4b738",
  null
  
)

export default component.exports